"use client"

import clsx from "clsx"

import { Popover, PopoverContent, PopoverTrigger } from "../../ui/popover"
import IconChevronDown from "../icons/IconChevronDown"
import IconUser from "../icons/IconUser"

type Props = {
  children: React.ReactNode
  displayName?: string
  open: boolean
  setOpen: (open: boolean) => void
}

const HeaderPopover = ({ children, displayName, open, setOpen }: Props) => {
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger onClick={() => setOpen(!open)}>
        <div className="hidden lg:flex gap-1 items-center cursor-pointer">
          Inloggad som:
          <span className="font-bold">{displayName}</span>
          <IconChevronDown
            className={clsx({
              "transform rotate-180": open
            })}
          />
        </div>
        <span
          className={clsx("lg:hidden", {
            "text-red": open
          })}>
          <IconUser />
        </span>
      </PopoverTrigger>
      <PopoverContent
        autoFocus={false}
        asChild={false}
        className="max-sm:w-[100vw] max-sm:z-40 max-sm:bg-white sm:mr-2 lg:rounded-xl p-6 md:p-8 border-0 rounded-none sm:rounded-lg sm:mt-8 lg:mt-0">
        {children}
      </PopoverContent>
    </Popover>
  )
}

export default HeaderPopover
